
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13504",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13504",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1128",
  "client-types": "static-1.510",
  "data-fetching-client": "static-1.10112",
  "foundations-components": "static-1.8744",
  "foundations-components-legacy": "static-1.1769",
  "foundations-theming": "static-1.4961",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.93",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8510",
  "hub-http-shared-msw-handlers": "static-1.10896",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11961",
  "I18n": "static-7.1706",
  "jasmine-runner": "static-1.6924",
  "marketplace-discovery-studio-lib": "static-1.901",
  "marketplace-storefront-base": "static-1.13567",
  "quartz": "static-1.7652",
  "react-dlb": "static-1.93",
  "react-rhumb": "static-1.17206",
  "reactive-variable-buffer-atom": "static-1.3325",
  "reporting-testing-lib": "static-1.11268",
  "reselect": "static-3.16",
  "settings-ui-lib": "static-1.13000",
  "SharedI18nStrings": "static-1.187",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7845",
  "ui-addon-i18n": "static-1.11619",
  "ui-addon-react-router-dom": "static-1.10000",
  "unified-auth": "static-1.1250",
  "unified-auth-core-lib": "static-1.1532",
  "usage-tracker": "static-1.7795",
  "usage-tracker-core": "static-1.7645",
  "customer-data-property-utils": "static-1.8523",
  "hub-http": "static-1.6680",
  "integrations-lib": "static-1.17423",
  "marketplace-ui-common": "static-1.21043",
  "marketplace-ui-install": "static-1.1029",
  "property-management-iframe": "static-1.14449",
  "quartz-config": "static-1.1430",
  "quartz-core": "static-1.6871",
  "quartz-routing": "static-1.1082",
  "quick-fetch": "static-1.4229",
  "react": "static-7.202",
  "rpc-client-utils": "static-1.5143",
  "ts-schema": "static-1.4391",
  "ui-universal-auth": "static-1.9736",
  "UIComponents": "static-3.8907",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3929",
  "quartz-webpack": "static-1.3876",
  "bend-plugin-quartz-routing": "static-1.730",
  "ai-components-ui-library": "static-1.10012",
  "codemirror": "static-5.106",
  "foundations-assets": "static-1.5358",
  "pulse": "static-1.1119",
  "react-codemirror": "static-1.11113",
  "ui-extensions-preview-lib": "static-1.954",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5013",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2677",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9895",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.101",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5654",
  "react-virtualized": "static-2.112",
  "StyleGuideUI": "static-3.518",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3073",
  "ui-fonts": "static-1.1223",
  "ui-images": "static-2.1276",
  "bend-plugin-foundations-theming": "static-1.3444",
  "foundations-theming-base": "static-1.3946",
  "stylex": "static-1.46",
  "HeadJS": "static-2.820",
  "hs-test-utils-bend-plugin": "static-1.3621",
  "msw": "static-1.102",
  "msw-config": "static-1.27",
  "testing-library": "static-1.164",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4781",
  "ui-addon-video-player": "static-1.9095",
  "ai-rendering-library": "static-1.11393",
  "chirp-fetch": "static-1.2376",
  "connections-embed-lib": "static-1.1741",
  "copilot-toolkit": "static-1.12139",
  "feedback-loader": "static-1.30056",
  "laboratory-lib": "static-3.7620",
  "marketplace-embed": "static-1.23197",
  "marketplace-ui-details": "static-1.10938",
  "marketplace-ui-reviews": "static-1.20998",
  "marketplace-ui-tracking": "static-1.15213",
  "sanitize-text": "static-1.8631",
  "usage-tracker-multi": "static-1.6209",
  "usage-tracker-session-replay": "static-1.5481",
  "beacon-keepalive-queue": "static-1.172",
  "quartz-head": "static-1.1317",
  "web-vitals": "static-1.19",
  "apollo-link-hub-http": "static-2.5060",
  "immer": "static-1.105",
  "immerable": "static-1.4615",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2832",
  "reporting-data": "static-1.69335",
  "cssUtils": "static-1.1096",
  "flux-actions": "static-1.380",
  "react-colorpicker": "static-2.10682",
  "react-dnd-compat": "static-1.5083",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10842",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7785",
  "icons": "static-2.702",
  "marketplace-ui-apps-core": "static-1.19575",
  "storybook-react": "static-1.44",
  "trellis-story-utils": "static-1.4971",
  "foundations-components-test-utils": "static-1.6227",
  "quartz-i18n": "static-1.1327",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.756",
  "ads-unified-auth-lib": "static-1.1954",
  "ai-mcp-auth-lib": "static-1.14",
  "custom-vendor-connection-lib": "static-1.300",
  "google-sheets-integration-lib": "static-1.1325",
  "microsoft-drive-auth-lib": "static-1.486",
  "slack-ui-library": "static-1.10871",
  "surveymonkey-integration-lib": "static-1.860",
  "fsm": "static-1.4231",
  "customer-data-objects": "static-1.8174",
  "property-translator": "static-1.5851",
  "hs-locale-management": "static-1.398",
  "frontend-preferences-client": "static-1.8392",
  "hs-promise-utils": "static-1.6065",
  "hubspot-apollo-client": "static-1.5353",
  "integrations-error-boundary-lib": "static-1.14838",
  "integrations-tracking-lib": "static-1.6091",
  "native-integrations-shared-strings": "static-1.8235",
  "sanitize": "static-1.4946",
  "superstore": "static-1.5231",
  "ui-shepherd-react": "static-3.10750",
  "ai-settings-ui-library": "static-1.8579",
  "hub-http-janus": "static-1.905",
  "hubspotter-http": "static-1.4973",
  "immutable-less": "static-1.5126",
  "marketplace-ui-client-types": "static-1.18450",
  "nav-meta": "static-1.30799",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18547",
  "ui-product-approvals-common": "static-1.1573",
  "ai-studio-lib": "static-1.12759",
  "hubspot-prosemirror": "static-1.19274",
  "integrations-reconnect-lib": "static-1.714",
  "ui-addon-iframeable": "static-1.9546",
  "ui-addon-integrations-directory-panel": "static-2.8426",
  "ui-product-approvals": "static-1.29678",
  "ui-tool-access": "static-1.10631",
  "inbound-db-properties-service-client": "static-1.4150",
  "property-management-common": "static-1.6737",
  "opentelemetry-fe-types": "static-1.264",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.604",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.639",
  "quartz-auth": "static-1.1327",
  "quartz-test": "static-1.1327",
  "quartz-tracking": "static-1.1031",
  "trellis-components": "static-1.3092",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.553",
  "HubStyle": "static-2.12268",
  "bender-build-tools": "static-1.3567",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23859",
  "ContentUtils": "static-1.69463",
  "customer-data-objects-ui-components": "static-1.13507",
  "sassPrefix": "static-1.360",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2019",
  "bend-plugin-pulse": "static-1.622",
  "event-emitter": "static-1.1435",
  "fast-json-patch": "static-1.74",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5906",
  "magpie-types": "static-1.5366",
  "stylex-utils": "static-1.173",
  "trellis-theming": "static-1.1471",
  "avatar-components": "static-1.2959",
  "breeze-engine-core": "static-1.1431",
  "breeze-engine-lib": "static-1.2153",
  "breeze-onboarding-components": "static-1.1057",
  "customer-data-filters-ui": "static-1.41348",
  "customer-data-reference-ui-components": "static-1.13646",
  "data-integrations-breeze": "static-1.302",
  "embedded-academy-lib": "static-1.15999",
  "ExportDialog": "static-6.10846",
  "global-styles-ai-lib": "static-1.487",
  "highlight.js": "static-1.90",
  "marketplace-embed-ba": "static-1.900",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.44",
  "reporting-action-components": "static-1.42393",
  "reporting-snowflake": "static-1.57951",
  "reporting-ui-components": "static-2.66604",
  "reporting-visualizations": "static-1.61409",
  "trial-components-library": "static-1.14371",
  "ui-addon-teams": "static-1.22008",
  "upgrade-components-lib": "static-1.713",
  "navigation-components": "static-1.19162",
  "nest": "static-1.707",
  "simple-logging-lib": "static-1.3524",
  "nudge-client-utils": "static-1.3414",
  "fail-safe": "static-1.420",
  "app-governance-lib": "static-1.2719",
  "developer-experience-shared-components": "static-1.11010",
  "purchase-motions-components": "static-1.6625",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10778",
  "usage-tracker-anonymous": "static-1.6212",
  "usage-tracker-public": "static-1.7606",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3773",
  "persist-promise": "static-1.4176",
  "reference-resolvers": "static-1.8654",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4389",
  "hubspot-apollo-cache": "static-1.812",
  "universal-page-editor-lib": "static-1.3483",
  "final-form": "static-1.83",
  "redux-toolkit": "static-1.82",
  "simple-data-table": "static-1.3813",
  "merchandise-lib": "static-1.284",
  "onboarding-scopes": "static-1.6924",
  "ui-addon-draggable": "static-3.5222",
  "content-assistance-lib": "static-1.8417",
  "content-media-capture": "static-1.5781",
  "customer-data-ui-utilities": "static-1.10307",
  "emoji-mart": "static-3.7",
  "file-manager-components": "static-1.24836",
  "growth-payments-core": "static-1.26495",
  "knowledge-content-types": "static-1.8760",
  "PatternValidationJS": "static-1.3358",
  "payment-link-components": "static-1.24449",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20548",
  "ui-addon-emoji-picker": "static-1.10335",
  "ui-business-units-lib": "static-1.9569",
  "video-components-external": "static-1.12423",
  "video-data-lib": "static-1.36081",
  "navigation-messaging": "static-1.8489",
  "collaboration-sidebar": "static-1.59046",
  "trellis-ext-dnd": "static-1.539",
  "crm-component-utils": "static-1.40179",
  "crm-properties-common-lib": "static-1.6366",
  "customer-data-properties": "static-1.53024",
  "external-options-client-types": "static-1.4438",
  "framework-data-schema-resolvers": "static-1.7365",
  "hs-resources": "static-1.665",
  "property-value-citations": "static-1.3638",
  "reference-resolvers-lite": "static-1.8582",
  "opentelemetry-web": "static-1.22",
  "hubspotter-http-shared-msw-handlers": "static-1.10894",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "cms-field-types": "static-1.5284",
  "content-icons-ui": "static-1.2455",
  "atom": "static-1.5544",
  "idb-keyval": "static-1.55",
  "reactive-lib": "static-1.1192",
  "trellis-migration-context": "static-1.51",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1131",
  "breeze-artifacts-sdk": "static-1.928",
  "getting-started-shared-tasks": "static-1.19555",
  "onboarding-journeys-lib": "static-1.1228",
  "conversations-skeleton-state": "static-1.7607",
  "crm-message-bus": "static-1.44095",
  "customer-data-filters-ui-msw-helpers": "static-1.23783",
  "events-data-lib": "static-1.718",
  "FormUrlGenerator": "static-2.5188",
  "framework-builder-read-service-client": "static-1.4333",
  "multi-account-reference-resolvers": "static-1.1482",
  "onboarding-tours": "static-1.17398",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14763",
  "segments-client-types": "static-1.12130",
  "academy-common-lib": "static-1.15460",
  "dashboard-lib": "static-1.83290",
  "hubspot-prosemirror-plugins": "static-1.19266",
  "share-with-third-party-component-lib": "static-1.9183",
  "ui-asset-management-lib": "static-1.11574",
  "user-context": "static-1.5525",
  "reporting-plugins": "static-1.10983",
  "reporting-reports": "static-1.69011",
  "hubs-service-types": "static-1.1739",
  "purchase-motions-api": "static-1.6628",
  "salesImages": "static-1.730",
  "signup-constants": "static-1.19936",
  "nudge-custom-function-registry": "static-1.3171",
  "nudge-renderer-utils": "static-1.3490",
  "whisper-core-api": "static-1.7629",
  "bend-plugin-fail-safe": "static-1.371",
  "framework-listing-lib": "static-2.29789",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31753",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4609",
  "signup-ui-url-generator": "static-2.8520",
  "onboarding-tours-client": "static-1.5613",
  "one-click-checkout": "static-1.741",
  "platform-infra-nav-components": "static-1.8001",
  "subscription-experience-data-types": "static-1.15434",
  "crm-record-cards-service-types": "static-1.3871",
  "location-customization-utils-lib": "static-1.10411",
  "redux-thunk": "static-2.84",
  "react-flip-move": "static-1.83",
  "ui-coaching-tips": "static-1.29580",
  "content-media-composition-data-lib": "static-1.13585",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4900",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3949",
  "seat-types-lib": "static-1.1047",
  "ui-addon-opt": "static-4.8876",
  "commerce-tours-lib": "static-1.6859",
  "growth-onboarding-reliability": "static-1.5555",
  "sales-checkout-service-client": "static-1.3996",
  "data-token-picker": "static-1.17129",
  "FileManagerLib": "static-1.40476",
  "content-media-compositions": "static-2.17592",
  "media-bridge-lib": "static-1.19636",
  "chatspot-widget-iframe": "static-1.23850",
  "collaboration-sidebar-common": "static-1.3843",
  "marketing-platform-lib": "static-1.7377",
  "dnd-kit": "static-1.21",
  "commerce-subscription-lib": "static-1.38046",
  "crm-actions": "static-1.6837",
  "crm-cards-sdk": "static-1.45006",
  "customer-data-properties-shared-msw-handlers": "static-1.10223",
  "customer-data-tracking": "static-1.7342",
  "calling-global-api": "static-1.66175",
  "calling-internal-common": "static-1.31797",
  "calling-lifecycle-internal": "static-1.67557",
  "calling-lifecycle-messages": "static-1.59850",
  "commerce-products-lib": "static-1.10904",
  "conditional-properties-service-client": "static-1.4111",
  "crm-index-visualization-core": "static-1.4753",
  "crm-links": "static-1.6782",
  "crm-pipelines-api-client-types": "static-1.4441",
  "formula-editor": "static-1.15007",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4518",
  "meetings-icalendar-utils-lib": "static-1.1107",
  "multi-currency-client-types": "static-1.4006",
  "object-builder-ui-client": "static-1.50038",
  "pipeline-validation-client-types": "static-1.4279",
  "smart-data-capture-core": "static-1.466",
  "smart-property-lib": "static-1.8646",
  "tiered-pricing": "static-1.2262",
  "topics-actions-lib": "static-1.657",
  "trellis-ext-i18n": "static-1.1383",
  "ui-addon-form-validation": "static-1.11347",
  "zustand": "static-1.89",
  "fdsr-migration-layer": "static-1.484",
  "framework-data-schema-quick-fetch": "static-1.7270",
  "restore-request-side-panel-lib": "static-1.2026",
  "growth-data-modal": "static-1.6130",
  "growth-onboarding-confetti": "static-1.3532",
  "growth-onboarding-next-action-utils": "static-1.2976",
  "onboarding-tours-utils": "static-1.1465",
  "ui-shepherd-tracker": "static-1.8131",
  "crm-index-associations-lib": "static-1.6922",
  "academy-service-client": "static-1.4164",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40335",
  "SafeStorage": "static-1.4868",
  "video-embed": "static-1.36915",
  "wootric-nps": "static-1.7295",
  "redux-actions": "static-3.74",
  "EmailSignatureEditor": "static-1.25242",
  "viral-links-lib": "static-1.7554",
  "nested-table": "static-1.704",
  "timezone-utils": "static-2.5703",
  "getting-started-shared-tasks-store": "static-1.18673",
  "campaign-roi-lib": "static-1.10815",
  "campaigns-utils-lib": "static-1.3718",
  "ui-addon-calendars": "static-2.5838",
  "customer-data-views-management": "static-1.26349",
  "framework-data-table": "static-2.12834",
  "nudge-custom-ui-functions": "static-1.1736",
  "switchboard-lib": "static-1.708",
  "access-check-ui-lib": "static-1.1879",
  "app-users-service-client": "static-1.6092",
  "app-users-service-types": "static-1.5500",
  "mini-checkout-client": "static-1.27836",
  "onboarding-utils": "static-1.5847",
  "permissions-shared-i18n-strings-fe": "static-1.2143",
  "ui-coaching-tips-shared-config": "static-1.29565",
  "checkout-sdk": "static-3.24679",
  "payment-method-components": "static-1.7314",
  "touchless-buying-components": "static-1.6547",
  "upgrade-catalog-service-types": "static-1.3897",
  "edison-service-client-types": "static-1.863",
  "growth-onboarding-feedback-components": "static-1.7056",
  "audio-components": "static-1.6565",
  "FileManagerImages": "static-1.37987",
  "video-components": "static-1.14425",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20483",
  "commerce-shared-components-lib": "static-1.19559",
  "commerce-tools-ui-lib": "static-1.11316",
  "crm_data": "static-4.93195",
  "crm-activity-creator-data": "static-1.47713",
  "crm-fe-perf": "static-1.23370",
  "universal-record-utils-lib": "static-1.2356",
  "calling-error-reporting": "static-1.31804",
  "shared-worker-versioning": "static-1.11513",
  "calling-usage-tracker": "static-1.7010",
  "voice-sms-access-library": "static-1.2431",
  "commerce-permissions": "static-1.1258",
  "products-iframe-lib": "static-1.8903",
  "products-ui-components-shared-msw-handlers": "static-1.11278",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10979",
  "sales-views-client-types": "static-1.4728",
  "bark-lib": "static-1.17004",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.909",
  "data-agent-test-utils": "static-1.453",
  "data-agent-utils": "static-1.922",
  "policy-lib": "static-1.7282",
  "react-tinymce": "static-1.56264",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11042",
  "tinymce-config": "static-2.55390",
  "tinymce-plugins": "static-1.58504",
  "onboarding-data-sync-lib": "static-1.2836",
  "growth-onboarding-next-action-components": "static-1.3004",
  "user-context-client": "static-1.4983",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4988",
  "outpost": "static-1.4601",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22353",
  "sales-email-signature-service-client": "static-1.4321",
  "ts-utils-lib": "static-1.622",
  "copilot-messaging": "static-1.2389",
  "crm-export-dialog": "static-1.6751",
  "crm-index-ui-shimmer": "static-1.2964",
  "crm-view-components": "static-1.1484",
  "react-beautiful-dnd": "static-1.75",
  "customer-data-associations": "static-1.7811",
  "tasks-actions-lib": "static-1.426",
  "InboxConnectUtils": "static-4.15838",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.877",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4460",
  "company-details-components": "static-1.6678",
  "react-performance-metrics-lib": "static-1.1026",
  "pricing-pages-ui-components": "static-1.16533",
  "quote-checkout-service-types": "static-1.3931",
  "social-insights-client-types": "static-1.22922",
  "utility-belt": "static-1.3009",
  "payments-enrollment-embed-lib": "static-1.24186",
  "stripe-embedded-components": "static-1.8240",
  "customer-data-rte": "static-1.33897",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6528",
  "payments-post-enroll-local-storage-lib": "static-1.5576",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39162",
  "crm_universal": "static-1.22720",
  "customer-data-email": "static-1.18635",
  "meetings-rte-lib": "static-1.538",
  "universal-associations-select": "static-1.11565",
  "crm-object-search-query-utilities": "static-1.10451",
  "calling-orchestration-schema": "static-1.37208",
  "react-reducer-toolkit": "static-1.16662",
  "enrichment-settings-lib": "static-1.228",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57360",
  "hub-http-contrib": "static-1.3503",
  "interframe": "static-3.5212",
  "tinymce-data": "static-1.41475",
  "ui-addon-sales-email": "static-1.5675",
  "layout-dnd-components": "static-1.13222",
  "layout-dnd-utils": "static-1.12197",
  "ui-brand-identity-lib": "static-1.16937",
  "meetings-connect-utils-lib": "static-1.8090",
  "company-details-service-types": "static-1.4416",
  "segments-query-core": "static-1.1904",
  "pricing-pages-api": "static-1.16398",
  "stripe-connect-js": "static-1.82",
  "draft-content-plugins": "static-1.29150",
  "sequences-lib": "static-1.8769",
  "ui-gdpr-components": "static-1.10655",
  "meetings-client-types": "static-1.4060",
  "meetings-core": "static-1.760",
  "NamespacedHubStyle": "static-2.9365",
  "ContentData": "static-1.69538",
  "layout-data-lib": "static-1.10522",
  "sequences-client-types-lib": "static-1.8626",
  "advanced-menus-core": "static-1.15812",
  "advanced-menus-lib": "static-1.12567",
  "ui-memberships-settings-lib": "static-1.35182",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15811",
  "simple-menus-lib": "static-1.17328"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13504",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1128",
  "client-types": "/client-types/static-1.510",
  "data-fetching-client": "/data-fetching-client/static-1.10112",
  "foundations-components": "/foundations-components/static-1.8744",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1769",
  "foundations-theming": "/foundations-theming/static-1.4961",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.93",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8510",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10896",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11961",
  "I18n": "/I18n/static-7.1706",
  "jasmine-runner": "/jasmine-runner/static-1.6924",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.901",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13567",
  "quartz": "/quartz/static-1.7652",
  "react-dlb": "/react-dlb/static-1.93",
  "react-rhumb": "/react-rhumb/static-1.17206",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3325",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11268",
  "reselect": "/reselect/static-3.16",
  "settings-ui-lib": "/settings-ui-lib/static-1.13000",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7845",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11619",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10000",
  "unified-auth": "/unified-auth/static-1.1250",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1532",
  "usage-tracker": "/usage-tracker/static-1.7795",
  "usage-tracker-core": "/usage-tracker-core/static-1.7645",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8523",
  "hub-http": "/hub-http/static-1.6680",
  "integrations-lib": "/integrations-lib/static-1.17423",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21043",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1029",
  "property-management-iframe": "/property-management-iframe/static-1.14449",
  "quartz-config": "/quartz-config/static-1.1430",
  "quartz-core": "/quartz-core/static-1.6871",
  "quartz-routing": "/quartz-routing/static-1.1082",
  "quick-fetch": "/quick-fetch/static-1.4229",
  "react": "/react/static-7.202",
  "rpc-client-utils": "/rpc-client-utils/static-1.5143",
  "ts-schema": "/ts-schema/static-1.4391",
  "ui-universal-auth": "/ui-universal-auth/static-1.9736",
  "UIComponents": "/UIComponents/static-3.8907",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3929",
  "quartz-webpack": "/quartz-webpack/static-1.3876",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.730",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10012",
  "codemirror": "/codemirror/static-5.106",
  "foundations-assets": "/foundations-assets/static-1.5358",
  "pulse": "/pulse/static-1.1119",
  "react-codemirror": "/react-codemirror/static-1.11113",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.954",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5013",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2677",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9895",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.101",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5654",
  "react-virtualized": "/react-virtualized/static-2.112",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3073",
  "ui-fonts": "/ui-fonts/static-1.1223",
  "ui-images": "/ui-images/static-2.1276",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3444",
  "foundations-theming-base": "/foundations-theming-base/static-1.3946",
  "stylex": "/stylex/static-1.46",
  "HeadJS": "/HeadJS/static-2.820",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3621",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.27",
  "testing-library": "/testing-library/static-1.164",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4781",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9095",
  "ai-rendering-library": "/ai-rendering-library/static-1.11393",
  "chirp-fetch": "/chirp-fetch/static-1.2376",
  "connections-embed-lib": "/connections-embed-lib/static-1.1741",
  "copilot-toolkit": "/copilot-toolkit/static-1.12139",
  "feedback-loader": "/feedback-loader/static-1.30056",
  "laboratory-lib": "/laboratory-lib/static-3.7620",
  "marketplace-embed": "/marketplace-embed/static-1.23197",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10938",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20998",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15213",
  "sanitize-text": "/sanitize-text/static-1.8631",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6209",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5481",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.172",
  "quartz-head": "/quartz-head/static-1.1317",
  "web-vitals": "/web-vitals/static-1.19",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5060",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4615",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2832",
  "reporting-data": "/reporting-data/static-1.69335",
  "cssUtils": "/cssUtils/static-1.1096",
  "flux-actions": "/flux-actions/static-1.380",
  "react-colorpicker": "/react-colorpicker/static-2.10682",
  "react-dnd-compat": "/react-dnd-compat/static-1.5083",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10842",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7785",
  "icons": "/icons/static-2.702",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19575",
  "storybook-react": "/storybook-react/static-1.44",
  "trellis-story-utils": "/trellis-story-utils/static-1.4971",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6227",
  "quartz-i18n": "/quartz-i18n/static-1.1327",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.756",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1954",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.14",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.300",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1325",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.486",
  "slack-ui-library": "/slack-ui-library/static-1.10871",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.860",
  "fsm": "/fsm/static-1.4231",
  "customer-data-objects": "/customer-data-objects/static-1.8174",
  "property-translator": "/property-translator/static-1.5851",
  "hs-locale-management": "/hs-locale-management/static-1.398",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8392",
  "hs-promise-utils": "/hs-promise-utils/static-1.6065",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5353",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14838",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6091",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8235",
  "sanitize": "/sanitize/static-1.4946",
  "superstore": "/superstore/static-1.5231",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10750",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8579",
  "hub-http-janus": "/hub-http-janus/static-1.905",
  "hubspotter-http": "/hubspotter-http/static-1.4973",
  "immutable-less": "/immutable-less/static-1.5126",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18450",
  "nav-meta": "/nav-meta/static-1.30799",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18547",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1573",
  "ai-studio-lib": "/ai-studio-lib/static-1.12759",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19274",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.714",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9546",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8426",
  "ui-product-approvals": "/ui-product-approvals/static-1.29678",
  "ui-tool-access": "/ui-tool-access/static-1.10631",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4150",
  "property-management-common": "/property-management-common/static-1.6737",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.264",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.604",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.639",
  "quartz-auth": "/quartz-auth/static-1.1327",
  "quartz-test": "/quartz-test/static-1.1327",
  "quartz-tracking": "/quartz-tracking/static-1.1031",
  "trellis-components": "/trellis-components/static-1.3092",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.553",
  "HubStyle": "/HubStyle/static-2.12268",
  "bender-build-tools": "/bender-build-tools/static-1.3567",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23859",
  "ContentUtils": "/ContentUtils/static-1.69463",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13507",
  "sassPrefix": "/sassPrefix/static-1.360",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2019",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.622",
  "event-emitter": "/event-emitter/static-1.1435",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5906",
  "magpie-types": "/magpie-types/static-1.5366",
  "stylex-utils": "/stylex-utils/static-1.173",
  "trellis-theming": "/trellis-theming/static-1.1471",
  "avatar-components": "/avatar-components/static-1.2959",
  "breeze-engine-core": "/breeze-engine-core/static-1.1431",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2153",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1057",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41348",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13646",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.302",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15999",
  "ExportDialog": "/ExportDialog/static-6.10846",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.487",
  "highlight.js": "/highlight.js/static-1.90",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.900",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.44",
  "reporting-action-components": "/reporting-action-components/static-1.42393",
  "reporting-snowflake": "/reporting-snowflake/static-1.57951",
  "reporting-ui-components": "/reporting-ui-components/static-2.66604",
  "reporting-visualizations": "/reporting-visualizations/static-1.61409",
  "trial-components-library": "/trial-components-library/static-1.14371",
  "ui-addon-teams": "/ui-addon-teams/static-1.22008",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.713",
  "navigation-components": "/navigation-components/static-1.19162",
  "nest": "/nest/static-1.707",
  "simple-logging-lib": "/simple-logging-lib/static-1.3524",
  "nudge-client-utils": "/nudge-client-utils/static-1.3414",
  "fail-safe": "/fail-safe/static-1.420",
  "app-governance-lib": "/app-governance-lib/static-1.2719",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11010",
  "purchase-motions-components": "/purchase-motions-components/static-1.6625",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10778",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6212",
  "usage-tracker-public": "/usage-tracker-public/static-1.7606",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3773",
  "persist-promise": "/persist-promise/static-1.4176",
  "reference-resolvers": "/reference-resolvers/static-1.8654",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4389",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.812",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3483",
  "final-form": "/final-form/static-1.83",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "simple-data-table": "/simple-data-table/static-1.3813",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "onboarding-scopes": "/onboarding-scopes/static-1.6924",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5222",
  "content-assistance-lib": "/content-assistance-lib/static-1.8417",
  "content-media-capture": "/content-media-capture/static-1.5781",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10307",
  "emoji-mart": "/emoji-mart/static-3.7",
  "file-manager-components": "/file-manager-components/static-1.24836",
  "growth-payments-core": "/growth-payments-core/static-1.26495",
  "knowledge-content-types": "/knowledge-content-types/static-1.8760",
  "PatternValidationJS": "/PatternValidationJS/static-1.3358",
  "payment-link-components": "/payment-link-components/static-1.24449",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20548",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10335",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9569",
  "video-components-external": "/video-components-external/static-1.12423",
  "video-data-lib": "/video-data-lib/static-1.36081",
  "navigation-messaging": "/navigation-messaging/static-1.8489",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59046",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.539",
  "crm-component-utils": "/crm-component-utils/static-1.40179",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6366",
  "customer-data-properties": "/customer-data-properties/static-1.53024",
  "external-options-client-types": "/external-options-client-types/static-1.4438",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7365",
  "hs-resources": "/hs-resources/static-1.665",
  "property-value-citations": "/property-value-citations/static-1.3638",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8582",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10894",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "cms-field-types": "/cms-field-types/static-1.5284",
  "content-icons-ui": "/content-icons-ui/static-1.2455",
  "atom": "/atom/static-1.5544",
  "idb-keyval": "/idb-keyval/static-1.55",
  "reactive-lib": "/reactive-lib/static-1.1192",
  "trellis-migration-context": "/trellis-migration-context/static-1.51",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1131",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.928",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19555",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1228",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7607",
  "crm-message-bus": "/crm-message-bus/static-1.44095",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23783",
  "events-data-lib": "/events-data-lib/static-1.718",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5188",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4333",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1482",
  "onboarding-tours": "/onboarding-tours/static-1.17398",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14763",
  "segments-client-types": "/segments-client-types/static-1.12130",
  "academy-common-lib": "/academy-common-lib/static-1.15460",
  "dashboard-lib": "/dashboard-lib/static-1.83290",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19266",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9183",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11574",
  "user-context": "/user-context/static-1.5525",
  "reporting-plugins": "/reporting-plugins/static-1.10983",
  "reporting-reports": "/reporting-reports/static-1.69011",
  "hubs-service-types": "/hubs-service-types/static-1.1739",
  "purchase-motions-api": "/purchase-motions-api/static-1.6628",
  "salesImages": "/salesImages/static-1.730",
  "signup-constants": "/signup-constants/static-1.19936",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3171",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3490",
  "whisper-core-api": "/whisper-core-api/static-1.7629",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.371",
  "framework-listing-lib": "/framework-listing-lib/static-2.29789",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31753",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4609",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5613",
  "one-click-checkout": "/one-click-checkout/static-1.741",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8001",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15434",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10411",
  "redux-thunk": "/redux-thunk/static-2.84",
  "react-flip-move": "/react-flip-move/static-1.83",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29580",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13585",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4900",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3949",
  "seat-types-lib": "/seat-types-lib/static-1.1047",
  "ui-addon-opt": "/ui-addon-opt/static-4.8876",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6859",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5555",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3996",
  "data-token-picker": "/data-token-picker/static-1.17129",
  "FileManagerLib": "/FileManagerLib/static-1.40476",
  "content-media-compositions": "/content-media-compositions/static-2.17592",
  "media-bridge-lib": "/media-bridge-lib/static-1.19636",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23850",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3843",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7377",
  "dnd-kit": "/dnd-kit/static-1.21",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38046",
  "crm-actions": "/crm-actions/static-1.6837",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45006",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10223",
  "customer-data-tracking": "/customer-data-tracking/static-1.7342",
  "calling-global-api": "/calling-global-api/static-1.66175",
  "calling-internal-common": "/calling-internal-common/static-1.31797",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67557",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59850",
  "commerce-products-lib": "/commerce-products-lib/static-1.10904",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4111",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4753",
  "crm-links": "/crm-links/static-1.6782",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4441",
  "formula-editor": "/formula-editor/static-1.15007",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4518",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1107",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4006",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50038",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4279",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.466",
  "smart-property-lib": "/smart-property-lib/static-1.8646",
  "tiered-pricing": "/tiered-pricing/static-1.2262",
  "topics-actions-lib": "/topics-actions-lib/static-1.657",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1383",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11347",
  "zustand": "/zustand/static-1.89",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.484",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7270",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2026",
  "growth-data-modal": "/growth-data-modal/static-1.6130",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3532",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2976",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1465",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8131",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6922",
  "academy-service-client": "/academy-service-client/static-1.4164",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40335",
  "SafeStorage": "/SafeStorage/static-1.4868",
  "video-embed": "/video-embed/static-1.36915",
  "wootric-nps": "/wootric-nps/static-1.7295",
  "redux-actions": "/redux-actions/static-3.74",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25242",
  "viral-links-lib": "/viral-links-lib/static-1.7554",
  "nested-table": "/nested-table/static-1.704",
  "timezone-utils": "/timezone-utils/static-2.5703",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18673",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10815",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3718",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5838",
  "customer-data-views-management": "/customer-data-views-management/static-1.26349",
  "framework-data-table": "/framework-data-table/static-2.12834",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1736",
  "switchboard-lib": "/switchboard-lib/static-1.708",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1879",
  "app-users-service-client": "/app-users-service-client/static-1.6092",
  "app-users-service-types": "/app-users-service-types/static-1.5500",
  "mini-checkout-client": "/mini-checkout-client/static-1.27836",
  "onboarding-utils": "/onboarding-utils/static-1.5847",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2143",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29565",
  "checkout-sdk": "/checkout-sdk/static-3.24679",
  "payment-method-components": "/payment-method-components/static-1.7314",
  "touchless-buying-components": "/touchless-buying-components/static-1.6547",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3897",
  "edison-service-client-types": "/edison-service-client-types/static-1.863",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7056",
  "audio-components": "/audio-components/static-1.6565",
  "FileManagerImages": "/FileManagerImages/static-1.37987",
  "video-components": "/video-components/static-1.14425",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20483",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19559",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11316",
  "crm_data": "/crm_data/static-4.93195",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47713",
  "crm-fe-perf": "/crm-fe-perf/static-1.23370",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2356",
  "calling-error-reporting": "/calling-error-reporting/static-1.31804",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11513",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7010",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2431",
  "commerce-permissions": "/commerce-permissions/static-1.1258",
  "products-iframe-lib": "/products-iframe-lib/static-1.8903",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11278",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10979",
  "sales-views-client-types": "/sales-views-client-types/static-1.4728",
  "bark-lib": "/bark-lib/static-1.17004",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.909",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.453",
  "data-agent-utils": "/data-agent-utils/static-1.922",
  "policy-lib": "/policy-lib/static-1.7282",
  "react-tinymce": "/react-tinymce/static-1.56264",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11042",
  "tinymce-config": "/tinymce-config/static-2.55390",
  "tinymce-plugins": "/tinymce-plugins/static-1.58504",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2836",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3004",
  "user-context-client": "/user-context-client/static-1.4983",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4988",
  "outpost": "/outpost/static-1.4601",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22353",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4321",
  "ts-utils-lib": "/ts-utils-lib/static-1.622",
  "copilot-messaging": "/copilot-messaging/static-1.2389",
  "crm-export-dialog": "/crm-export-dialog/static-1.6751",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2964",
  "crm-view-components": "/crm-view-components/static-1.1484",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.75",
  "customer-data-associations": "/customer-data-associations/static-1.7811",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.426",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15838",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.877",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4460",
  "company-details-components": "/company-details-components/static-1.6678",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1026",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16533",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3931",
  "social-insights-client-types": "/social-insights-client-types/static-1.22922",
  "utility-belt": "/utility-belt/static-1.3009",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24186",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8240",
  "customer-data-rte": "/customer-data-rte/static-1.33897",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6528",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5576",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39162",
  "crm_universal": "/crm_universal/static-1.22720",
  "customer-data-email": "/customer-data-email/static-1.18635",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.538",
  "universal-associations-select": "/universal-associations-select/static-1.11565",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10451",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37208",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16662",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.228",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57360",
  "hub-http-contrib": "/hub-http-contrib/static-1.3503",
  "interframe": "/interframe/static-3.5212",
  "tinymce-data": "/tinymce-data/static-1.41475",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5675",
  "layout-dnd-components": "/layout-dnd-components/static-1.13222",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12197",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16937",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8090",
  "company-details-service-types": "/company-details-service-types/static-1.4416",
  "segments-query-core": "/segments-query-core/static-1.1904",
  "pricing-pages-api": "/pricing-pages-api/static-1.16398",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "draft-content-plugins": "/draft-content-plugins/static-1.29150",
  "sequences-lib": "/sequences-lib/static-1.8769",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10655",
  "meetings-client-types": "/meetings-client-types/static-1.4060",
  "meetings-core": "/meetings-core/static-1.760",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9365",
  "ContentData": "/ContentData/static-1.69538",
  "layout-data-lib": "/layout-data-lib/static-1.10522",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8626",
  "advanced-menus-core": "/advanced-menus-core/static-1.15812",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12567",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35182",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15811",
  "simple-menus-lib": "/simple-menus-lib/static-1.17328"
}
};
